// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_GetDevicesByFranquiasInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/devices_franquias/get_devices_by_franquias
 *
 * Fetches all messaging devices (WhatsApp/Instagram) for the given franchise IDs.
 */
import { registerContract } from './validate'

export interface DevicesFranquias_GetDevicesByFranquiasInput {
franquia_ids: number[]
}

registerContract('DevicesFranquias_GetDevicesByFranquiasInput', {
  franquia_ids: { type: 'array',   required: true },
})
